import './databricksConsulting.scss';
import Header from '../../src-utilities/header';
import './../../src-utilities/footer';
// import './../../src-utilities/ourOffering';
import Swiper from './../../../node_modules/swiper';
import { Autoplay, EffectFade, Navigation, Pagination } from 'swiper/modules';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/all';
import './../../src-utilities/getInTouch';
import rightChoice from './../../src-utilities/rightChoice';
import './../../src-utilities/industries';
import AOS from 'aos';
import testimonial from '../../src-utilities/testimonial';
// import '../../src-utilities/cta';
import JustValidate from './../../../node_modules/just-validate';

new Header();

AOS.init({
	initClassName: 'animation-init',
	animatedClassName: 'animation',
	once: true,
	easing: 'ease-in-quart',
});

gsap.registerPlugin(ScrollTrigger);

var loading_global = document.querySelector('.loading-div');
let GoogleSendURL =
	'https://script.google.com/macros/s/AKfycbyML8OHUDSwwvY_QcBlZ2uHYN_rQIx_VlWZPLjpxoJ9dB8GQEr6J7U0D8kNzC3-p0nH/exec';

const requestConsulting = document.querySelector(
	'.contact-us-form-wrapper #databricks-consulting-static-form',
);

const consultingRequestForm = new JustValidate(
	'#databricks-consulting-static-form',
);

consultingRequestForm
	.addField('#databricks-consultant-fullName', [
		{
			rule: 'required',
		},
		{
			rule: 'minLength',
			value: 2,
		},
		{
			rule: 'customRegexp',
			value: /^(?=\S)([A-Za-z]+(?:\s+[A-Za-z]+){1,})$/,
			errorMessage: 'Enter Valid Full Name',
		},
	])
	.addField('#databricks-consultant-companyEmail', [
		{
			rule: 'required',
		},
		{
			rule: 'email',
		},
		{
			validator: (value) => {
				let emailRegex =
					/^[a-zA-Z0-9](?:[a-zA-Z0-9._-]*[a-zA-Z0-9])?@[a-zA-Z0-9-]+(\.[a-zA-Z]{2,7})+$/;
				return emailRegex.test(value);
			},
			errorMessage: 'Please Enter Valid Email Address',
		},
	])
	.addField('#databricks-consultant-phonecode', [
		{
			rule: 'required',
		},
	])
	.addField('#databricks-consultant-phoneNumber', [
		{ rule: 'required' },
		{
			rule: 'minLength',
			value: 4,
		},
		{
			rule: 'maxLength',
			value: 15,
		},
		{
			rule: 'customRegexp',
			value: /^(?![-+])[0-9]+$/,
			errorMessage: 'Enter Valid Phone Number',
		},
	])
	.addField('#databricks-consultant-meeting-agenda', [
		{
			rule: 'required',
		},
	]);

requestConsulting.addEventListener('submit', async (event) => {
	event.preventDefault();
	if (consultingRequestForm.isValid == false) {
		return false;
	}
	loading_global.classList.add('active');

	let formData = new FormData(event.target);
	let fullName = formData.get('lfirstname').split(' ');
	let firstName, lastName;
	[firstName, ...lastName] = fullName;
	lastName = lastName.join(' ');
	formData.set('lfirstname', firstName);
	formData.set('llastname', lastName);
	formData.append('sendurlvalue', window.location.href);
	formData.append('lsource', 'databricks-consulting');

	const myHeaders = new Headers();
	myHeaders.append('Content-Type', 'application/json');

	// Initiate the Sales IQ visitor data
	if (window.$zoho && window.$zoho.salesiq) {
		try {
			$zoho.salesiq.visitor.uniqueid();
			$zoho.salesiq.visitor.name(firstName + ' ' + lastName);
			$zoho.salesiq.visitor.email(formData.get('lemail'));
			console.log('SalesIQ Name/Email set');
		} catch (error) {
			console.warn('SalesIQ Error:', error);
		}
	}

	const raw = JSON.stringify({
		firstName: formData.get('lfirstname'),
		lastName: formData.get('llastname'),
		email: formData.get('lemail'),
		phone: formData.get('phonecode') + ' ' + formData.get('lphone'),
		description: formData.get('meetingAgenda'),
		leadSource: formData.get('lsource'),
		websiteVisitURL: window.location.href,
	});

	const requestOptions = {
		method: 'POST',
		headers: myHeaders,
		body: raw,
		redirect: 'follow',
	};
	const googleRequestOptions = {
		method: 'GET',
		redirect: 'follow',
	};
	let request = '?';
	[...formData].forEach(([key, value], index) => {
		request += `${index === 0 ? '' : '&'}${key + '=' + value}`;
	});

	// Request 1: Main Backend
	const backendRequest = fetch(
		'https://us-west1-zoho-crm-scripts.cloudfunctions.net/queueLeadHttp',
		requestOptions,
	);

	// Request 2: Update the Google Sheet Data
	const googleRequest = fetch(GoogleSendURL + request, googleRequestOptions);

	// Waiting until these request get's completed
	try {
		await Promise.allSettled([backendRequest, googleRequest]);
	} catch (e) {
		console.error('API Error', e);
	}

	// Redirect
	window.location.href =
		'https://cyntexa.com/success/?msg=databricks-consulting-submission';
});

// salesforce-experties gsap pinned horizontal scroll (Desktop and Tablet above 768px)
gsap.matchMedia().add('(min-width: 769px)', () => {
	let sections = gsap.utils.toArray('.salesforce-experties .box');
	let boxes = document.querySelector('.salesforce-experties .boxes');

	if (sections.length && boxes) {
		let expertisTL = gsap.timeline({
			scrollTrigger: {
				trigger: '.salesforce-experties',
				start: 'center center',
				end: () => boxes.offsetWidth + 'bottom',
				scrub: true,
				pin: '.salesforce-experties',
				pinSpacing: true,
				pinType: 'fixed',
			},
		});

		expertisTL.to(sections, {
			duration: 3,
			xPercent: -75 * sections.length,
		});
	}
});

// #region our-offering
let headings = Array.from(
	document.querySelectorAll('.offering-headings .offering-heading'),
);

let parentContainer = document.querySelector('.offering-container');
let currentActive;

const swiper = new Swiper('.offering-details', {
	speed: 400,
	modules: [Autoplay],
	breakpoints: {
		1050: {
			spaceBetween: 50,
		},
	},
	on: {
		init: function () {
			currentActive = headings[this.activeIndex];
			if (currentActive) {
				currentActive.classList.add('active-offering');
			}
		},
	},
});

swiper.on('autoplayTimeLeft', function (a, b, percentage) {
	if (parentContainer) {
		parentContainer.style.setProperty(
			'--active-width',
			`${100 - percentage * 100}%`,
		);
	}
});

headings.forEach((element) => {
	element.addEventListener('click', (event) => {
		if (window.innerWidth <= 768) {
			const isActive = element.classList.contains('active-offering');

			headings.forEach((h) => {
				h.classList.remove('active-offering');
			});

			if (!isActive) {
				element.classList.add('active-offering');
			}
		} else {
			swiper.slideTo(element.dataset.id, 500);
		}
	});
});

swiper.on('slideChange', function () {
	if (window.innerWidth > 768) {
		if (currentActive) {
			currentActive.classList.remove('active-offering');
		}
		currentActive = headings[this.activeIndex];
		if (currentActive) {
			currentActive.classList.add('active-offering');
		}
	}
});

// #endregion - our-offering

//faq section js code
const BindEvent = () => {
	let faq_question = document.getElementsByClassName('faq-question');
	let hiddenFaqs = document.querySelectorAll('.hidden-faq');
	let viewAllFaqBtn = document.querySelector('.faq-view-btn');

	for (let i = 0; i < faq_question.length; i++) {
		const question = faq_question[i];
		question.addEventListener('click', function (e) {
			let all_faq = document.getElementsByClassName('faq');
			let isopen =
				e.currentTarget.parentNode.classList.contains('active');
			for (let index = 0; index < all_faq.length; index++) {
				all_faq[index].classList.remove('active');
			}
			if (isopen == false) {
				e.currentTarget.parentNode.classList.add('active');
			}
		});
	}

	viewAllFaqBtn.addEventListener('click', () => {
		if (!viewAllFaqBtn.classList.contains('active')) {
			viewAllFaqBtn.textContent = 'View Less';
			viewAllFaqBtn.classList.add('active');
			hiddenFaqs.forEach((hiddenFaq) => {
				hiddenFaq.style.display = 'flex';
			});
		} else {
			viewAllFaqBtn.textContent = 'View All';
			viewAllFaqBtn.classList.remove('active');
			hiddenFaqs.forEach((hiddenFaq) => {
				hiddenFaq.style.display = 'none';
			});
		}
	});
};
BindEvent();

// right choice section
rightChoice();

// Testimonial
testimonial();

// our customer
new Swiper('.customers-logo', {
	modules: [Autoplay],
	slidesPerView: 'auto',
	spaceBetween: 30,
	speed: 3000,
	freeMode: true,
	freeModeMomentum: false,
	autoplay: {
		delay: 0,
		disableOnInteraction: false,
		pauseOnMouseEnter: false,
	},
	loop: true,
	breakpoints: {
		0: {
			spaceBetween: 0,
		},
		600: {
			spaceBetween: 20,
		},
		1024: {
			spaceBetween: 30,
		},
	},
});

window.addEventListener('resize', function () {
	ScrollTrigger.refresh();
});

// Reserve Popup
let reservePopUp = document.querySelector('.reserve-spot-popup-screen');
let reserveOpen = document.querySelectorAll('.databricks-consulting-open');
let reserveClose = document.querySelector('.reserve-close-btn');

reserveOpen.forEach((e) => {
	e.addEventListener('click', () => {
		reservePopUp.classList.add('open');
	});
});

reserveClose.addEventListener('click', () => {
	reservePopUp.classList.remove('open');
});
// Reserve Popup

// region Form Popup JS Code
const validate_popup = new JustValidate('#databricks-consulting-pop-up-form');

validate_popup
	.addField('#databricks-consulting-popup-fullname', [
		{
			rule: 'required',
		},
		{
			rule: 'minLength',
			value: 2,
		},
		{
			rule: 'customRegexp',
			value: /^(?=\S)([A-Za-z]+(?:\s+[A-Za-z]+){1,})$/,
			errorMessage: 'Enter Valid Full Name',
		},
	])
	.addField('#databricks-consulting-popup-email', [
		{
			rule: 'required',
		},
		{
			rule: 'email',
		},
		{
			validator: (value) => {
				let emailRegex =
					/^[a-zA-Z0-9](?:[a-zA-Z0-9._-]*[a-zA-Z0-9])?@[a-zA-Z0-9-]+(\.[a-zA-Z]{2,7})+$/;
				return emailRegex.test(value);
			},
			errorMessage: 'Please Enter Valid Email Address',
		},
	])
	.addField('#databricks-consulting-popup-phonenumber', [
		{
			rule: 'required',
		},
		{
			rule: 'minLength',
			value: 4,
		},
		{
			rule: 'maxLength',
			value: 15,
		},
		{
			rule: 'customRegexp',
			value: /^(?![-+])[0-9]+$/,
			errorMessage: 'Enter Valid Phone Number',
		},
	])
	.addField('#databricks-consulting-popup-country-phone-code', [
		{
			rule: 'required',
		},
	])
	.addField('#databricks-consulting-popup-meeting-agenda', [
		{
			rule: 'required',
		},
	]);

document
	.querySelector('#databricks-consulting-pop-up-form')
	.addEventListener('submit', async (event) => {
		event.preventDefault();
		if (validate_popup.isValid == false) {
			return false;
		}
		document.querySelector('.loading-div').classList.add('active');
		const form = document.getElementById(
			'databricks-consulting-pop-up-form',
		);
		const formData = new FormData(form);
		let fullName = formData.get('lfullname').split(' ');
		let firstName, lastName;
		[firstName, ...lastName] = fullName;
		lastName = lastName.join(' ');
		formData.set('lfirstname', firstName);
		formData.set('llastname', lastName);
		formData.append('sendurlvalue', window.location.href);
		formData.set('lsource', 'databricks-consulting');

		let myHeaders = new Headers();
		myHeaders.append('Content-Type', 'application/json');

		// Initiate the Sales IQ visitor data
		if (window.$zoho && window.$zoho.salesiq) {
			try {
				$zoho.salesiq.visitor.uniqueid();
				$zoho.salesiq.visitor.name(firstName + ' ' + lastName);
				$zoho.salesiq.visitor.email(formData.get('lemail'));
				console.log('SalesIQ Name/Email set');
			} catch (error) {
				console.warn('SalesIQ Error:', error);
			}
		}

		let raw = JSON.stringify({
			firstName: formData.get('lfirstname'),
			lastName: formData.get('llastname'),
			email: formData.get('lemail'),
			phone: formData.get('lphone'),
			description: formData.get('meetingAgendaPopup'),
			leadSource: formData.get('lsource'),
			websiteVisitURL: window.location.href,
		});

		let requestOptions = {
			method: 'POST',
			headers: myHeaders,
			body: raw,
			redirect: 'follow',
		};

		const googleRequestOptions = {
			method: 'GET',
			redirect: 'follow',
		};
		let request = '?';
		[...formData].forEach(([key, value], index) => {
			request += `${index === 0 ? '' : '&'}${key + '=' + value}`;
		});

		// Request 1: Main Backend
		const backendRequest = fetch(
			'https://us-west1-zoho-crm-scripts.cloudfunctions.net/queueLeadHttp',
			requestOptions,
		);

		// Request 2: Update the Google Sheet Data
		const googleRequest = fetch(
			GoogleSendURL + request,
			googleRequestOptions,
		);

		// Waiting until these request get's completed
		try {
			await Promise.allSettled([backendRequest, googleRequest]);
		} catch (e) {
			console.error('API Error', e);
		}

		// Redirect
		window.location.href =
			'https://cyntexa.com/success/?msg=databricks-consulting-submission';
	});
// endregion  Form Popup JS Code

// Mobile Compare Slider
const compareSliderEl = document.querySelector('.mobile-compare-slider');
if (compareSliderEl) {
	const mobileCompareSlider = new Swiper(compareSliderEl, {
		slidesPerView: 1,
		spaceBetween: 20,
		modules: [Autoplay, Pagination],
		autoplay: {
			delay: 5000,
			pauseOnMouseEnter: true,
			disableOnInteraction: false,
		},
		pagination: {
			el: '.mobile-compare-slider .swiper-pagination',
			clickable: true,
		},
		breakpoints: {
			768: {
				// Unused on desktop since it's hidden, but we'll set it just in case
				slidesPerView: 1,
			},
		},
	});

	// Stop autoplay initially so it doesn't run before reaching the section
	mobileCompareSlider.autoplay.stop();

	// Start autoplay when the slider enters the viewport
	const sliderObserver = new IntersectionObserver(
		(entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					mobileCompareSlider.autoplay.start();
				} else {
					mobileCompareSlider.autoplay.stop();
				}
			});
		},
		{ threshold: 0.2 },
	);

	sliderObserver.observe(compareSliderEl);
}
